import React, { useEffect, useState } from 'react';
import {
  StyledDiv,
  StyledInfiniteScroll,
  StyledSpan
} from '../../Theme/CommonStyled';
import BrandContainerWithLogo from '../Common/BrandContainerWithLogo';
import useLandingStore from '../../Store/Landing';
import Title from '../Common/Title';
import purchase from '../../Assets/images/purchases.svg';
import usePurchasesStore from '../../Store/Purchases';
import LoadingSpinner from '../Common/LoadingSpinner';
import {
  StyledInvoiceContainer,
  StyledInvoiceDetail,
  StyledItemIcon
} from './style';
import Icon from '../Common/Icon';
import DetailsRow from '../Common/DetailsRow';
import { useTranslation } from 'react-i18next';
import { convertToPersian } from '../../Utils/common.util';
import LoadingBox from '../Common/LoadingBox';
import { useNavigate } from 'react-router';

const Purchases: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const landingData = useLandingStore((state) => state.landingData);
  const purchasesData = usePurchasesStore((state) => state.purchasesData);
  const getPurchasesDataAction = usePurchasesStore(
    (state) => state.getPurchasesDataAction
  );
  const hasMoreData = usePurchasesStore((state) => state.hasMoreData);
  const setHasMoreDataAction = usePurchasesStore(
    (state) => state.setHasMoreDataAction
  );

  const [dataLength, setDataLength] = useState(
    5 + (purchasesData?.customerFactorBriefList.length || 0)
  );

  const getMoreData = () => {
    setTimeout(async () => {
      const response = await getPurchasesDataAction({
        clubBranchId: landingData?.branchId,
        skip: dataLength - 5,
        take: 5
      });

      if (response?.length !== 5) {
        setHasMoreDataAction(false);
      } else {
        setDataLength((dataLength) => dataLength + 5);
        setHasMoreDataAction(true);
      }
    }, 500);
  };

  useEffect(() => {
    !purchasesData && getMoreData();
  }, []);

  return (
    <StyledDiv pt={'80px'} px={8} direction="rtl">
      <BrandContainerWithLogo
        brandName={landingData?.brandName}
        logo={landingData?.logoUrl}
        brandNameStyle={{ mb: '0 !important' }}
      />
      <Title title={<img src={purchase} alt={'purchase'} />} my={12} />
      <LoadingBox loading={!purchasesData}>
        <StyledDiv pb={10}>
          <StyledInfiniteScroll
            scrollableTarget="main-container"
            next={getMoreData}
            loader={
              <StyledDiv
                width="100%"
                display="flex"
                justifyContent="center"
                mt={8}>
                <LoadingSpinner width={'20px'} height={'20px'} type="green" />
              </StyledDiv>
            }
            hasMore={hasMoreData}
            dataLength={dataLength}>
            {purchasesData?.customerFactorBriefList?.map((item, index) => (
              <StyledInvoiceContainer
                key={item.factureId}
                onClick={(): void =>
                  navigate(`/facture/${item.factureId}`, { state: index + 1 })
                }>
                <StyledInvoiceDetail>
                  <StyledItemIcon>
                    <Icon
                      name="bill"
                      fontSize={14}
                      mb={5}
                      color="secondaryText"
                    />
                    <StyledSpan fontSize={4} color="secondaryText">
                      {`${t('purchases.invoice')} ${index + 1}`}
                    </StyledSpan>
                  </StyledItemIcon>
                  <StyledDiv
                    dispaly="flex"
                    justifyContent="center"
                    alignItems="center"
                    flex={4}>
                    <DetailsRow
                      mb={4}
                      color="secondaryText"
                      title={`${t('global.number')}: `}
                      value={
                        <StyledSpan color="primaryBlue" letterSpacing="0.2rem">
                          {convertToPersian(
                            item.factureOrginalId.toString().slice(-4)
                          )}
                        </StyledSpan>
                      }
                    />
                    <DetailsRow
                      mb={4}
                      color="secondaryText"
                      title={`${t('global.date')}: `}
                      value={
                        <StyledSpan
                          color="secondaryText"
                          letterSpacing="0.3rem">
                          {new Date(item.dateTime).toLocaleString('fa-IR', {
                            year: 'numeric',
                            month: 'numeric',
                            day: 'numeric'
                          })}
                        </StyledSpan>
                      }
                    />
                    <DetailsRow
                      color="secondaryText"
                      title={`${t('global.time')}: `}
                      value={
                        <StyledSpan
                          color="secondaryText"
                          letterSpacing="0.2rem">
                          {new Date(item.dateTime).toLocaleString('fa-IR', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </StyledSpan>
                      }
                    />
                  </StyledDiv>
                  <StyledDiv mr={8} ml={4} display="flex" alignItems="center">
                    <Icon name="enter-1" color="disableBg" fontSize={2} />
                  </StyledDiv>
                </StyledInvoiceDetail>
              </StyledInvoiceContainer>
            ))}
          </StyledInfiniteScroll>
        </StyledDiv>
      </LoadingBox>
    </StyledDiv>
  );
};

export default Purchases;
